import { HomeGallery } from '../components/HomeGallery';
import { HomeHero } from '../components/HomeHero';
import { HomeStaff } from '../components/HomeStaff';
import { Seo } from '../components/Seo';
import { ServicesPanel } from '../components/ServicesPanel';
import { SiteLinks } from '../components/SiteLinks';

const Home: Page = () => {
    return (
        <main>
            <Seo
                title="Outpatient Center Tarzana, CA | Surgical Center– Vytalcenter"
                description="Vytal Center is committed to the highest quality outpatient services. The doctors are highly experienced in the medical and surgical field"
            />
            <HomeHero />
            <HomeStaff />
            <HomeGallery />
            <ServicesPanel homepage />
            <SiteLinks />
        </main>
    );
};

export default Home;
